import { Modal, ModalBody } from "reactstrap";
import CrossIcon from "../../../../components/Icons/CrossIcon";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import EditIcon from "../../../../components/Icons/EditIcon";
import { useState } from "react";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";

const RequestSelectorModal = ({ modal, toggle, handleCreateNew, handleEditExisting, handleDeleteExisting }) => {
    const [hoveredCard, setHoveredCard] = useState(null);

    const cardStyle = (isHovered, borderColor) => ({
        transition: "all 0.3s ease",
        transform: isHovered ? "translateY(-5px)" : "none",
        border: `2px solid ${isHovered ? borderColor : "#e9ecef"}`,
        boxShadow: isHovered ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
        cursor: "pointer",
        height: "100%",
        minHeight: "220px",
        backgroundColor: "#fff",
        borderRadius: "12px"
    });

    return (
        <Modal isOpen={modal} toggle={toggle} centered size="lg">
            <ModalBody className="p-2">
                <div className="d-flex justify-content-end mb-2">
                    <span
                        className="cursor-pointer p-2 rounded-circle hover-bg-light"
                        onClick={toggle}
                        style={{ cursor: "pointer" }}
                    >
                        <CrossIcon />
                    </span>
                </div>

                <h3 className="text-center mb-5 rajdhani-semibold" style={{ fontSize: "1.50rem" }}>What would you like to do?</h3>

                <div className="row g-2 justify-content-center">
                    <div className="col-12 col-md-4">
                        <div
                            className="card border-0"
                            onClick={handleCreateNew}
                            onMouseEnter={() => setHoveredCard('create')}
                            onMouseLeave={() => setHoveredCard(null)}
                            style={cardStyle(hoveredCard === 'create', "#048604")}
                        >
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div
                                    className="rounded-circle mb-4 d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        backgroundColor: hoveredCard === 'create' ? "#eef5ff" : "#f8f9fa",
                                        transition: "background-color 0.3s ease"
                                    }}
                                >
                                    <PlusIcon width={20} height={20} color="#048604" />
                                </div>
                                <h5 className="fw-bold mb-2">Add New Expense Head</h5>
                                {/* <p className="text-muted mb-0 small">Start a fresh expense head from scratch</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div
                            className="card border-0"
                            onClick={handleEditExisting}
                            onMouseEnter={() => setHoveredCard('edit')}
                            onMouseLeave={() => setHoveredCard(null)}
                            style={cardStyle(hoveredCard === 'edit', "#0dcaf0")}
                        >
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div
                                    className="rounded-circle mb-4 d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        backgroundColor: hoveredCard === 'edit' ? "#effbff" : "#f8f9fa",
                                        transition: "background-color 0.3s ease"
                                    }}
                                >
                                    <EditIcon width={38} height={38} className="text-info" />
                                </div>
                                <h5 className="fw-bold mb-2">Edit Existing Expense Head</h5>
                                {/* <p className="text-muted mb-0 small">Edit or view submitted expense head</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div
                            className="card border-0"
                            onClick={handleDeleteExisting}
                            onMouseEnter={() => setHoveredCard('delete')}
                            onMouseLeave={() => setHoveredCard(null)}
                            style={cardStyle(hoveredCard === 'delete', "#dc3545")}
                        >
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div
                                    className="rounded-circle mb-4 d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        backgroundColor: hoveredCard === 'delete' ? "#ffebee" : "#f8f9fa",
                                        transition: "background-color 0.3s ease"
                                    }}
                                >
                                    <DeleteIcon width={20} height={20} color="#dc3545" />
                                </div>
                                <h5 className="fw-bold mb-2">Delete Existing Expense Head</h5>
                                {/* <p className="text-muted mb-0 small">Remove an existing expense head</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default RequestSelectorModal;
